"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-expressions */
// React
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const Sticky_1 = __importDefault(require("./Sticky"));
const constants_1 = require("./constants");
const PikolinHeader_1 = __importDefault(require("./PikolinHeader"));
const TopBar_1 = __importDefault(require("./TopBar"));
const MovistarMenu_1 = __importDefault(require("./MovistarMenu"));
const SectionMenu_1 = __importDefault(require("./SectionMenu"));
// genero version
// Components
const Header = (props) => {
    let userType = (0, react_redux_1.useSelector)((state) => state.main.context.userType);
    const infoContextApiFailed = (0, react_redux_1.useSelector)((state) => state.main.context.infoContextApiFailed);
    if (infoContextApiFailed) {
        userType = '';
    }
    const sectionMenu = (0, react_redux_1.useSelector)((state) => state.header.sectionMenu);
    const movistarMenuInfo = (0, react_redux_1.useSelector)((state) => state.header.movistarMenuInfo);
    let currentSectionMenu = null;
    if (!userType && sectionMenu && sectionMenu.public) {
        currentSectionMenu = sectionMenu.public;
    }
    else if (sectionMenu && sectionMenu.telco) {
        currentSectionMenu = sectionMenu.telco;
    }
    let fixedMenu = currentSectionMenu && currentSectionMenu.fixedMenu;
    if (fixedMenu) {
        fixedMenu = constants_1.MMENU_FIXED;
    }
    else {
        fixedMenu = constants_1.DEFAULT_FIXED;
    }
    const taggingInfo = {
        componentContent: '',
        componentName: 'header',
        componentPerso: '',
        componentProduct: '',
        componentVariation: 'all',
    };
    if (process.env.NEXT_PUBLIC_WEB_VIEW === 'true') {
        return null;
    }
    if ((currentSectionMenu === null || currentSectionMenu === void 0 ? void 0 : currentSectionMenu.type) === constants_1.LAYOUT_TYPES.WORK_SPACE) {
        return react_1.default.createElement(PikolinHeader_1.default, Object.assign({}, props, { taggingInfo: taggingInfo }));
    }
    if (!movistarMenuInfo) {
        return null;
    }
    if (fixedMenu === constants_1.MMENU_FIXED) {
        return (react_1.default.createElement("header", { className: "HeaderM" },
            react_1.default.createElement(Sticky_1.default, null,
                react_1.default.createElement(TopBar_1.default, { taggingInfo: taggingInfo }),
                react_1.default.createElement(MovistarMenu_1.default, { taggingInfo: taggingInfo }),
                react_1.default.createElement(SectionMenu_1.default, { taggingInfo: taggingInfo }))));
    }
    return (react_1.default.createElement("header", { className: "HeaderM" },
        react_1.default.createElement(TopBar_1.default, { taggingInfo: taggingInfo }),
        react_1.default.createElement(MovistarMenu_1.default, { taggingInfo: taggingInfo }),
        react_1.default.createElement(Sticky_1.default, null,
            react_1.default.createElement(SectionMenu_1.default, { taggingInfo: taggingInfo }))));
};
exports.default = Header;
//# sourceMappingURL=index.js.map